module.exports = __webpack_public_path__ + "static/media/gridskillsPTBg.be21bc92.jpg";